module.exports = __webpack_public_path__ + "static/nigel-ball-c8f321c10ebffefa8048e6cf2fa8c48b.png";